import { GetOrder } from 'smg/customer-api/orders';
import * as html from 'smg/html';
import QueryString from 'smg/querystring';
import * as lineitems from '../lineitems';

void main();

async function main() {
    const orderNum = document.querySelector('#order-num') as HTMLSpanElement;
    const deliveryData = document.querySelector('#deliveryData') as HTMLLIElement;
    const emailContainer = document.querySelector('#emailContainer') as HTMLElement;
    const email = document.querySelector('#email') as HTMLSpanElement;
    const phoneContainer = document.querySelector('#phoneContainer') as HTMLElement;
    const phoneNumber = document.querySelector('#phone-number') as HTMLSpanElement;
    const orderContainer = document.querySelector('#orderContainer') as HTMLElement;
    const alert = document.querySelector('#alert') as HTMLElement;
    const spinner = document.querySelector('#spinner') as HTMLDivElement;
    const content = document.querySelector('#content') as HTMLDivElement;

    const key = QueryString().get('id');

    function failed() {
        const noKey = document.querySelector('#noKey') as HTMLElement;
        noKey.classList.remove('d-none');
    }

    function stopSpinner() {
        spinner.classList.add('d-none');
    }

    // This runs if there is a key in the url
    if (key) {
        try {
            const data = await GetOrder(key, {
                data: 'invoiceNumber,balance,orderShippingOptions,orderLineItems',
            });
            const order = data;
            if (!order) {
                stopSpinner();
                failed();
                return;
            }

            // Filling Out My Order Field
            orderNum.innerText = String(order.invoiceNumber);

            // Check if the shipping options are populated
            if (order.orderShippingOptions.length) {
                const shippingOption = order.orderShippingOptions[0].shippingOption;
                if (shippingOption) {
                    const shippingAddress = shippingOption.address;
                    deliveryData.innerHTML = html.Nl2br(html.Escape(shippingAddress.toStringWithoutContact()));

                    if (shippingAddress.phoneNumber?.phone) {
                        phoneContainer.classList.remove('d-none');
                        phoneNumber.innerText = shippingAddress.phoneNumber.phone;
                    }

                    if (shippingAddress.emailAddress?.email) {
                        emailContainer.classList.remove('d-none');
                        email.innerText = shippingAddress.emailAddress.email;
                    }
                }
            }

            // Creating my Order Table

            // Checking for line items. If that exists, select the table and add the 'table-dark' class to it
            if (order.orderLineItems.length) {
                orderContainer.append(await lineitems.Table(order.orderLineItems));
                const table = document.querySelector('table') as HTMLTableElement;
                table.classList.add('table-dark');
            }

            // Checking if Cash balance is 0, for error message
            if (order.balance.gt(0)) {
                alert.classList.remove('d-none');
            }

            // Remove spinner from page
            stopSpinner();

            // Make page visible
            content.classList.remove('d-none');
        } catch (err) {
            stopSpinner();
            failed();
        }
        // If there is not a key in the url
    } else {
        stopSpinner();
        failed();
    }
}
